import { HHDSIconType, HHDSIcons } from './IconType';
import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSIconTagName: string = 'hhds-icon';
const TAG_NAME: string = HHDSIconTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export class HHDSIcon extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');
		const iconType = (this.vars.get<string>('type') as HHDSIconType) || HHDSIconType.None;
		const iconContent = HHDSIcons[iconType] ? HHDSIcons[iconType] : '';
		if (iconType !== HHDSIconType.None) {
			this.setInnerHtml('', '', `<div class="hhds-icon">${iconContent}</div>`);
		}
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Attribute changed: ', name, _oldValue, newValue);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
		if (elements.length == 0) {
			DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Slot emptied');
		} else {
			DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'Slot changed');
		}
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	type: {
		description: 'The type of icon to be displayed.',
		defaultValue: HHDSIconType.None,
		typeString: 'HHDSIconType',
		type: HHDSIconType,
	},
};
